module.exports = __webpack_public_path__ + "static/img/fr-16.df312635.png";